<template>
  <header :class="headerClass" :style="{position: headerPosition}">
    <div class="overlay" @click="(menuTrigger = false), (alertTrigger = false)" :style="menuTrigger || alertTrigger ? {display: 'block'} : {display: 'none'}"></div>
    <nav :class="navAdjust">
      <h1>
        <router-link :to="{name: 'Top'}">
          <img src="@/assets/images/header/rakutap_logo.png" />
        </router-link>
      </h1>
      <div id="pcmenu">
        <ul id="mybtn" :class="$style.hello">
          <li v-if="!loggedIn && !serverLogged && !viewLogin">
            <a class="popup-modal" @click="openLoginModal">{{ $t("header.login") }}</a>
          </li>
          <li v-if="loggedIn || serverLogged" @click="(menuTrigger = false), (alertTrigger = false)">
            <a @click="logout()" style="cursor: pointer;">{{ $t("header.logout") }}</a>
          </li>
        </ul>
        <div v-if="loggedIn || serverLogged" id="alerticon">
          <a @click="alertTrigger = !alertTrigger">
            <span>{{ noneReadListLength }}</span>
          </a>
        </div>
        <ul id="mainlist" :class="[$style.hello, 'menuhover']">
          <li class="pc" @click="(menuTrigger = false), (alertTrigger = false)">
            <a href="#" v-scroll-to="'#brand'" :style="lineupScroll ? '' : {display: 'none'}">
              {{ $t("header.brand") }}
            </a>
            <router-link v-if="!lineupScroll" to="/#brand">{{ $t("header.brand") }}</router-link>
          </li>
          <li @click="(menuTrigger = false), (alertTrigger = false)">
            <router-link :to="{name: 'Service'}">{{ $t("header.serviceOverview") }}</router-link>
          </li>
          <li @click="(menuTrigger = false), (alertTrigger = false)">
            <router-link :to="{name: 'StoreList'}">{{ $t("header.storeSearch") }}</router-link>
          </li>
          <li @click="(menuTrigger = false), (alertTrigger = false)">
            <router-link :to="{name: 'SavedPlanList'}">{{ $t("header.mypage") }}</router-link>
          </li>
        </ul>
      </div>
      <div id="slidemenu">
        <div id="slidemenu--inner">
          <ul id="mybtn" :class="$style.mobileMenu">
            <li v-if="!loggedIn && !serverLogged && !viewLogin">
              <a class="popup-modal" @click="openLoginModal">{{ $t("header.login") }}</a>
            </li>
            <li v-if="loggedIn || serverLogged" @click="(menuTrigger = false), (alertTrigger = false)">
              <a @click="logout()" style="cursor: pointer;">{{ $t("header.logout") }}</a>
            </li>
          </ul>
          <div id="listtop">
            <dl>
              <dt>LINEUP</dt>
              <dd>
                <div class="accordion_menu" v-for="(brand, i) in brandPlanList" :key="i">
                  <div class="accordion_header pre_header" @click="toggleLineupAccordion(brand.brandNo)" :class="accordion[i].lineupOpened ? 'accordion_header pre_header open' : 'accordion_header pre_header'" v-if="i == 0 || (i > 0 && brandPlanList[i].brandNo != brandPlanList[i - 1].brandNo)">
                    {{ brand.brandName }}
                    <div class="i_box"><i class="one_i"></i></div>
                  </div>
                  <transition @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
                    <div class="accordion_header_inner" v-show="accordion[i].lineupOpened">
                      <div class="accordion_menu">
                        <div class="accordion_header_inner" v-if="brand.planGroupStatusCd == '001'">
                          <div class="listtop_plan">
                            <a href="javascript:void(0)" v-for="plan in brand.planOptionList" :key="plan.planId" @click="detailPlan(plan.planId, plan.specDiv, plan.entranceDirectionCd)"> <span>Type</span>{{ plan.planName }} </a>
                          </div>
                        </div>
                      </div>
                      <div class="accordion_menu" v-if="brand.planGroupStatusCd != '001'">
                        <div @click="toggleGroupAccordion(i)" :class="accordion[i].groupOpened ? 'accordion_header sec_header open' : 'accordion_header sec_header'">
                          {{ brand.planGroupName }}
                          <div class="i_box"><i class="one_i"></i></div>
                        </div>
                        <transition name="opt" @before-enter="optBeforeEnter" @enter="optEnter" @before-leave="optBeforeLeave" @leave="optLeave">
                          <div class="accordion_header_inner" v-show="accordion[i].groupOpened">
                            <div class="listtop_plan">
                              <a href="javascript:void(0)" v-for="plan in brand.planOptionList" :key="plan.planId" @click="detailPlan(plan.planId, plan.specDiv, plan.entranceDirectionCd)"> <span>Type</span>{{ plan.planName }} </a>
                            </div>
                          </div>
                        </transition>
                      </div>
                    </div>
                  </transition>
                </div>
              </dd>
            </dl>
          </div>
          <ul id="mainlist" :class="[$style.mobileMenu, 'menuhover']">
            <!-- クレバリーホーム対応フラグによって画面表示を切り替えるように対応 -->
            <li class="pc" v-if="cleverlyHomeFlg" @click="(menuTrigger = false), (alertTrigger = false)">
              <a href="#" v-scroll-to="'#brand'" :style="lineupScroll ? '' : {display: 'none'}">
                {{ $t("header.brand") }}
              </a>
              <router-link v-if="!lineupScroll" to="/#brand">{{ $t("header.brand") }}</router-link>
            </li>
            <li class="pc" v-if="!cleverlyHomeFlg" @click="(menuTrigger = false), (alertTrigger = false)">
              <a href="#" v-scroll-to="'#lineup'" :style="lineupScroll ? '' : {display: 'none'}">{{ $t("header.lineup") }}</a>
              <router-link v-if="!lineupScroll" to="/#lineup">{{ $t("header.lineup") }}</router-link>
            </li>
            <li @click="(menuTrigger = false), (alertTrigger = false)">
              <router-link :to="{name: 'Service'}">{{ $t("header.serviceOverview") }}</router-link>
            </li>
            <li @click="(menuTrigger = false), (alertTrigger = false)">
              <router-link :to="{name: 'SavedPlanList'}">{{ $t("header.mypage") }}</router-link>
            </li>
          </ul>
          <ul>
            <li @click="(menuTrigger = false), (alertTrigger = false)">
              <router-link :to="{name: 'Reservation'}">{{ $t("header.reservation") }}</router-link>
            </li>
            <li v-if="isMainDomain" @click="(menuTrigger = false), (alertTrigger = false)">
              <router-link :to="{name: 'Basicstructure'}">{{ $t("header.basicStructure") }}</router-link>
            </li>
            <li @click="(menuTrigger = false), (alertTrigger = false)">
              <router-link :to="{name: 'Notice'}">{{ $t("header.news") }}</router-link>
            </li>
            <li @click="(menuTrigger = false), (alertTrigger = false)">
              <router-link :to="{name: 'Company'}">{{ $t("header.companyOverview") }}</router-link>
            </li>
            <li>
              <a href="https://its-house.co.jp/" target="_blank">{{ $t("header.brandSite") }}</a>
            </li>
            <li @click="(menuTrigger = false), (alertTrigger = false)">
              <router-link :to="{name: 'StoreList'}">{{ $t("header.storeSearch") }}</router-link>
            </li>
          </ul>
          <li @click="(menuTrigger = false), (alertTrigger = false)">
            <a @click="openOtherWindow('Contact')" class="cursor" id="btncontact">{{ $t("header.inquiry") }}</a>
          </li>
          <ul id="logout">
            <li v-if="!loggedIn && !serverLogged" @click="(menuTrigger = false), (alertTrigger = false)">
              <router-link :to="{name: 'MailAddress'}">{{ $t("header.signUp") }}</router-link>
            </li>
            <li v-if="loggedIn || serverLogged">
              <a @click="logout()" style="cursor: pointer;">{{ $t("header.logout") }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="panel" @click="menuTrigger = !menuTrigger">
        <div :class="menuTrigger ? 'menu-trigger active' : 'menu-trigger'"><span></span><span></span><span></span></div>
      </div>
      <div id="alertmenu">
        <button @click="alertTrigger = false">✖</button>
        <div id="alertmenu--inner">
          お知らせ
          <nav class="noneReadChkBox">
            <input id="alreadyReadCheck" type="checkbox" v-model="alreadyReadCheck" />
            <span>未読のみ</span>
          </nav>
          <ul>
            <li v-for="alreadyRead in setAlarmList" :key="alreadyRead.adminAlertNo" :class="alreadyRead.alreadyReadFlg == '0' ? 'noneRead' : 'alreadyRead'" @click="movingScreen(alreadyRead)">
              <a>
                <p>【{{ alreadyRead.alertTitle }}】</p>
                <div class="alert-text">{{ alreadyRead.alertMessage }}</div>
                <small>{{ alreadyRead.alertDateStr }}</small>
              </a>
            </li>
            <li v-show="listMax < noticeAlertList.length">
              <a @click="increaseMaxList" class="moreAlertList">もっと見る</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <!-- 建築地入力確認モーダル -->
    <magnific-popup-modal :show="false" :config="modalOption" :modalStyle="{id: 'popup-add', class: 'contentpopup add'}" ref="modal">
      <constr-alert :planId="selectedPlanId" :specDiv="selectedPlanSpecDiv" :entranceDirectionCd="selectedPlanEntCd" />
    </magnific-popup-modal>
    <!-- ログインモーダル -->
    <magnific-popup-modal :show="false" :config="modalOption" :modalStyle="{id: 'popup-login', class: 'contentpopup login'}" ref="loginModal">
      <login-input v-on:login-input="closeLoginModal" v-on:login-success="loginSuccess" v-on:mail-regist="goMailRegist" v-on:pw-reissue="goPwReissue" />
    </magnific-popup-modal>
    <!-- アラート確認モーダル -->
    <magnific-popup-modal :show="false" :config="modalOption" :modalStyle="{id: 'popup-login', class: 'contentpopup add'}" ref="alertModal">
      <alert-view :alertInfo="alertInfo" v-on:move-destination="moveDestination" />
    </magnific-popup-modal>
  </header>
</template>

<script>
import magnificPopupModal from "@/components/parts/MagnificPopupModal.vue";
import constrSiteAlert from "@/components/parts/ConstrSiteAlert.vue"; // eslint-disable-line no-unused-vars
import alertView from "@/components/parts/AlertView.vue";
import loginInput from "@/components/authentication/LoginInput.vue";
import constConfig from "@/common/const";
import Cookies from "js-cookie";
import axios from "axios";
export default {
  data() {
    return {
      cleverlyHomeFlg: this.$store.state.cleverlyHomeFlg,
      isMainDomain: this.$store.state.isMainDomain,
      selectedPlanId: undefined,
      selectedPlanSpecDiv: undefined,
      selectedPlanEntCd: undefined,
      viewId: constConfig.VIEW_TOP.id,
      thisView: constConfig.VIEW_TOP,
      modalOption: constConfig.MODAL_OPTION,
      menuTrigger: false,
      alertTrigger: false,
      noticeAlertList: [],
      brandPlanList: [],
      alreadyReadCheck: false,
      listMax: 10,
      noneReadListLength: 0,
      alertInfo: {},
      test: false,
      accordion: [],
    };
  },
  created: async function() {
    if (this.$route) this.thisView = this.$route;
    await this.init();
    await this.getBrandGroupPlan();
  },
  mounted() {
    this.$nextTick(() => {
      const mql = window.matchMedia(this.$style.breakpoint);
      this.func(mql);
      mql.addListener(this.func);
    });
  },
  components: {
    "magnific-popup-modal": magnificPopupModal,
    "constr-alert": constrSiteAlert,
    "login-input": loginInput,
    "alert-view": alertView,
  },
  computed: {
    // ヘッダーバーのスタイル
    headerClass() {
      if (this.thisView) return this.thisView.name == constConfig.VIEW_TOP.name ? "bgtranslucent" : "bgdefault";
      return "bgdefault";
    },
    headerPosition() {
      if (this.$route.name && (this.$route.name == constConfig.VIEW_PLAN_DETAIL.name || this.$route.name == constConfig.VIEW_SAVED_PLAN_DETAIL.name)) {
        return "sticky";
      } else {
        return "fixed";
      }
    },
    lineupScroll() {
      if (this.thisView) {
        if (this.thisView.name == constConfig.VIEW_TOP.name) {
          return true;
        }
      }
      return false;
    },
    loggedIn: {
      get() {
        return this.$store.state.loggedIn;
      },
    },
    serverLogged: {
      get() {
        return this.$store.state.serverLogged;
      },
    },
    navAdjust: function() {
      if (this.menuTrigger) {
        return "active";
      } else if (this.alertTrigger) {
        return "view";
      } else {
        return "";
      }
    },
    setAlarmList: function() {
      let settedAlarmList = [];
      if (this.alreadyReadCheck) {
        settedAlarmList = this.noticeAlertList.filter((list) => list.alreadyReadFlg == "0");
      } else {
        settedAlarmList = this.noticeAlertList;
      }
      return settedAlarmList.slice(0, this.listMax);
    },
    viewLogin: function() {
      if (this.$route && this.$route.name == constConfig.VIEW_VIA_LOGIN.name) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    $route: "changeRoute",
  },
  methods: {
    init: async function() {
      await axios
        .post("/api/authentication/isLoggedIn")
        .then((res) => {
          if (res.data.result == 1) {
            this.$store.commit("setServerLogged", false);
          } else {
            this.$store.commit("setServerLogged", true);
            this.noticeAlertList = res.data.noticeAlertList;
            this.noneReadListLength = this.noticeAlertList.filter((list) => list.alreadyReadFlg == "0").length;
          }
        })
        .catch(() => {
          this.$router.push({name: "Error"});
        });
    },
    getBrandGroupPlan: async function() {
      await axios
        .post("/api/top/getBrandPlanList")
        .then((res) => {
          if (res.data.result == 0) {
            this.$store.commit("setServerLogged", true);
            this.brandPlanList = res.data.brandPlanList;
            // アコーディオン設定
            this.accordion = [];
            for (let k = 0; k < this.brandPlanList.length; k++) {
              let accordionObj = {
                brandNo: this.brandPlanList[k].brandNo,
                planGroupId: this.brandPlanList[k].planGroupId,
                lineupOpened: false,
                groupOpened: false,
              };
              this.accordion.push(accordionObj);
            }
          }
        })
        .catch(() => {
          this.$router.push({name: "Error"});
        });
    },
    changeRoute: function(to) {
      this.menuTrigger = false;
      this.alertTrigger = false;
      this.thisView = to;
      this.updateAlert();
    },
    updateAlert: function() {
      if (this.$store.state.loggedIn || this.$store.state.serverLogged) {
        this.getAlert();
      }
    },
    func(mql) {
      this.test = mql.matches;
    },
    getAlert: function() {
      axios
        .post("/api/authentication/isLoggedIn")
        .then((res) => {
          if (res.data.result == 1) {
            this.$store.commit("setServerLogged", false);
          } else {
            this.$store.commit("setServerLogged", true);
            this.noticeAlertList = res.data.noticeAlertList;
            this.noneReadListLength = this.noticeAlertList.filter((list) => list.alreadyReadFlg == "0").length;
          }
        })
        .catch((error) => {
          console.log(error);
          this.$router.push({name: "Error"});
        });
    },
    detailPlan: function(planId, specDiv, entranceDirectionCd) {
      this.menuTrigger = false;
      this.alertTrigger = false;
      this.selectedPlanId = planId;
      this.selectedPlanSpecDiv = specDiv;
      this.selectedPlanEntCd = entranceDirectionCd;
      this.$refs.modal.open();
    },
    movingScreen: function(alert) {
      const formData = new FormData();
      formData.append("adminAlertNo", alert.adminAlertNo);
      axios
        .post("/api/authentication/notice-read", formData)
        .then((res) => {
          if (res.data.result == 1) {
            this.$store.commit("setServerLogged", false);
            this.$router.push({name: "Error"});
          } else {
            this.$store.commit("setServerLogged", true);
            // アラートモーダル表示（画面遷移はボタン押下処理：moveDestination）
            this.alertTrigger = false;
            this.menuTrigger = false;
            this.alertInfo = alert;
            this.$refs.alertModal.open();
          }
        })
        .catch((error) => {
          console.log(error);
          this.$router.push({name: "Error"});
        });
    },
    // マイページへ
    moveDestination: function() {
      this.$refs.alertModal.close();
      if (this.$route && this.$route.name == "SavedPlanDetail") {
        if (this.$route.query.simulationNo == this.alertInfo.simulationNo) {
          this.reload();
        } else {
          // this.$router.push({ path: '/mypage/saved-plan/detail', query: { simulationNo: this.alertInfo.simulationNo }});
          const url = "/mypage/saved-plan/detail?simulationNo=" + this.alertInfo.simulationNo;
          location.href = url;
        }
      } else {
        this.$router.push({
          path: "/mypage/saved-plan/detail",
          query: {simulationNo: this.alertInfo.simulationNo},
        });
      }
    },
    increaseMaxList: function() {
      this.listMax += 10;
    },
    loginSuccess: function() {
      this.$refs.loginModal.close();
      this.getAlert();
      if (this.thisView.name == "Error") {
        this.$router.push({name: "Top"});
      }
    },
    logout: function() {
      axios
        .post("/api/authentication/logout/check")
        .then((res) => {
          if (res.data.result == 1) {
            this.$router.push({name: "Error"});
          } else {
            Cookies.remove("livnex_cookie_authKey");
            this.$store.commit("setLoggedIn", false);
            this.$store.commit("setServerLogged", false);
            if (this.thisView.name == constConfig.VIEW_TOP.name) {
              // 表示画面がTOPの場合、画面をリロード
              this.$router.go({
                path: this.$router.currentRoute.path,
                force: true,
              });
            } else {
              // 表示画面がTOP以外の場合、TOP画面に遷移
              this.$router.push({name: "Top"});
            }
          }
        })
        .catch(() => {
          this.$router.push({name: "Error"});
        });
    },
    openLoginModal: function() {
      this.$refs.loginModal.open();
    },
    closeLoginModal: function() {
      this.$refs.loginModal.close();
    },
    goMailRegist: function() {
      this.$refs.loginModal.close();
      // メールアドレス登録画面へ
      this.$router.push({
        name: "MailAddress",
        params: {transitionId: constConfig.VIEW_TOP.id},
      });
    },
    goPwReissue: function() {
      this.$refs.loginModal.close();
      // メールアドレス登録画面へ
      this.$router.push({
        name: "PasswordReissue",
        params: {transitionId: constConfig.VIEW_TOP.id},
      });
    },
    // オプションLINEUP開閉
    toggleLineupAccordion: function(brandNo) {
      this.accordion.forEach((acc) => {
        if (acc.brandNo == brandNo) {
          acc.lineupOpened = !acc.lineupOpened;
        } else {
          acc.lineupOpened = false;
          acc.groupOpened = false;
        }
      });
    },
    // オプションGROUP開閉
    toggleGroupAccordion: function(i) {
      this.accordion[i].groupOpened = !this.accordion[i].groupOpened;
    },
    // オプションリスト
    beforeEnter(el) {
      el.style.height = "0";
    },
    enter(el) {
      el.style.height = el.scrollHeight - 5 + "px";
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight - 5 + "px";
    },
    leave(el) {
      el.style.height = "0";
    },
    optBeforeEnter(el) {
      el.style.height = "0";
    },
    optEnter(el) {
      el.style.height = el.scrollHeight + "px";
      let lineupHeight = el.parentElement.parentElement.style.height.replace("px", "");
      el.parentElement.parentElement.style.height = parseInt(lineupHeight) + el.scrollHeight + "px";
    },
    optBeforeLeave(el) {
      el.style.height = el.scrollHeight + "px";
      let lineupHeight = el.parentElement.parentElement.style.height.replace("px", "");
      el.parentElement.parentElement.style.height = parseInt(lineupHeight) - el.scrollHeight + "px";
    },
    optLeave(el) {
      el.style.height = "0";
    },
  },
};
</script>
<style lang="postcss" module>
@value breakpoint: (max-width: 900px);

.hello {
  display: block;
}
.mobileMenu {
  display: none;
}

@media breakpoint {
  .hello {
    display: none;
  }
  .mobileMenu {
    display: block;
  }
}
</style>
<style lang="scss">
.noneRead {
  opacity: 1;
}
.alreadyRead {
  opacity: 0.2;
}
</style>
<style lang="css" scoped>
#listtop .accordion_menu {
  width: 100%;
}
#listtop .accordion_header_inner {
  transition: all 0.5s;
  box-sizing: border-box;
}
#listtop .accordion_menu .accordion_header {
  position: relative;
  z-index: +1;
  transition-duration: 0.2s;
  background-color: #545454;
  color: #fff;
  font-size: 2.1rem;
  line-height: 1em;
  padding: 16px 20px;
  text-align: left;
  border-bottom: 1px solid #222222;
}
#listtop .accordion_menu .accordion_menu .accordion_header {
  background-color: #757575;
  padding: 16px 30px;
}
#listtop .accordion_menu .accordion_header .i_box {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  right: 2.5%;
  width: 40px;
  height: 40px;
  margin-top: -20px;
  box-sizing: border-box;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  transform-origin: center;
  transition-duration: 0.2s;
}
#listtop .accordion_menu .accordion_header .i_box .one_i {
  display: block;
  width: 18px;
  height: 18px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  transform-origin: center;
  transition-duration: 0.2s;
  position: relative;
}
#listtop .accordion_menu .accordion_header.open .i_box {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}
#listtop .accordion_menu .accordion_header .i_box .one_i:before,
#listtop .accordion_menu .accordion_header .i_box .one_i:after {
  display: flex;
  content: "";
  background-color: #fff;
  width: 18px;
  height: 2px;
  position: absolute;
  top: 8px;
  left: 0;
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  transform-origin: center center;
}
#listtop .accordion_menu .accordion_header .i_box .one_i:before {
  width: 2px;
  height: 18px;
  top: 0;
  left: 8px;
}
#listtop .accordion_menu .accordion_header.open .i_box .one_i:before {
  content: none;
}
#listtop .accordion_menu .accordion_header.open .i_box .one_i:after {
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
#listtop .listtop_plan {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  background-color: #fff;
}
header nav #slidemenu #listtop dl dd {
  max-height: inherit;
  background-color: #000;
}
</style>
